module.exports = __webpack_public_path__ + "static/media/licious.deb46666.svg";